<template>
  <div>
    <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div class="large-panel pt-3">
      <span class="main-title">Exception submission request</span>

      <div class="row no-gutters">
        <div class="col-md-9 col-12 my-3">
          <router-link :to="{path: '/'}" class="solution-link">
            <font-awesome-icon icon="arrow-left" size="sm"/>
            Go to Supplier Central home
          </router-link>
        </div>
      </div>


      <form-validation-errors v-if="activeTabIndex < 1" />
      <div class="row no-gutters">
        <div class="col-12 mt-2 p-4 form-outline col-print-12">
          <div class="justify-content-end">
            <button class="close close-btn" @click="navigateToHome()" :disabled="isLoading">
              <font-awesome-icon icon="times" />
            </button>
          </div>

          <alert-message class="px-md-5 px-0 my-3" v-if="errorMessage"></alert-message>
          <form-header :current-tab="currentTab" :tab-items="tabs" :current-user="currentUser" />

          <component class="px-md-5 px-0"
                     :is="currentComponent"
                     @setCurrentTab="setCurrentTab"
                     :backNav="tabs[0].component"
                     :nextNav="tabs[1].component" />
        </div>
      </div>
      <support :showSupportWhenLoading="true"></support>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import GeneralInformationForExceptionRequest
  from "@/components/ExceptionSubmissionRequest/GeneralInformationForExceptionRequest";
import SupplierInformationForExceptionRequest
  from "@/components/ExceptionSubmissionRequest/SupplierInformationForExceptionRequest";
import PreviewDetailsForExceptionRequest
  from "@/components/ExceptionSubmissionRequest/PreviewDetailsForExceptionRequest";
import LoadingSpinner from "@/components/LoadingSpinner";
import Support from "@/components/Support";
import AlertMessage from "@/components/AlertMessage";
import PreviewInvoiceSubmission from "@/components/Payments/InvoiceSubmission/PreviewInvoiceSubmission";
import FormValidationErrors from "@/components/Payments/FormValidationErrors";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";
import FormHeader from "@/components/Payments/FormHeader";
import ExceptionRequestMixin from "@/mixins/exceptionRequestMixin";

export default {
  name: "ExceptionSubmissionRequestForm",
  components: {
    FormValidationErrors,
    LoadingSpinner,
    GeneralInformationForExceptionRequest,
    SupplierInformationForExceptionRequest,
    PreviewDetailsForExceptionRequest,
    Support,
    AlertMessage,
    PreviewInvoiceSubmission,
    FormHeader
  },
  mixins: [ExceptionRequestMixin],
  computed: {
    ...mapGetters(["isLoading","currentUser","errorMessage",'formValidationErrors','exceptionSubmissionRequestData'])
  },
  watch: {
    currentTab(val) {
      this.currentComponent = val
      this.activeTabIndex = this.tabs.findIndex(tab => tab.component === val)
    }
  },
  data(){
    return{
      activeTabIndex: 0,
      currentComponent: '',
      tabs: EXCEPTION_SUBMISSION_CONSTANTS.TAB_ITEMS,
      currentTab: ""
    }
  },
  created: function () {
    this.initializeExceptionSubmissionRequestData()
  },
  beforeDestroy() {
    this.clearAllFormsData()
  },
  methods:{
    ...mapActions(["clearAllFormsData","getSupplierCountryListData","fetchAllAdminDataRequiredList"]),
    async initializeExceptionSubmissionRequestData(){
      this.currentComponent = this.tabs[0].component
      this.currentTab = this.tabs[0].component
      this.validateSupplierCountryListData()
    },

    validateSupplierCountryListData(){
      if (!this.supplierCountryList || this.supplierCountryList.length === 0)
      {
        this.getSupplierCountryListData()
      }
    },
    onNavItemClicked(index) {
      this.activeTabIndex = index
      this.currentComponent = this.tabs[index].component
    },
    setCurrentTab(tab) {
      window.scrollTo(0,0)
      this.currentComponent = this.tabs.find(item => item.component === tab).component
      this.currentTab = this.tabs.find(item => item.component === tab).component
    }
  }

}
</script>

<style scoped>
.large-panel {
  padding-bottom: 30px;
  margin: 0px 0px 15px 0px;
  min-height: 350px;
}

@media (max-width: 1000px) {
  .nav-tabs li {
    width: 100%;
  }
}

.nav-tabs,
.nav-link {
  border: none;
  border-radius: 0;
  border: 0 !important;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color:inherit;
}
.nav-tabs li a.active {
  color: #0696d7;
  font-weight: bold;
  border-bottom: 4px #0696d7 solid !important;
}
.navitem-active {
  color: #0696d7 !important;
  font-weight: bold !important;
  border-bottom: 2px #0696d7 solid !important;
  padding: 1px;
}
.nav-tabs{
  border:none;
}
.nav-tabs{
  border:none;
}
.nav-tabs li a {
  min-width: 100px;
  height: 75px;
  padding-top: 25px;
  text-align: center;
  color: #000;
  font-size: 14px;
}
</style>
